/* REACT PACKAGE IMPORTS */
import { StrictMode, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";

/* INTERNAL IMPORTS */
import App from "./App";
import MSALApp from "./MSALApp";
import { store } from "./App/store";
import ThemeContextWrapper from "./Theme/ThemeWrapper";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.css";

/* ENTRA IMPORTS */
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

/* ============= MSAL Setup ============= */
/**
 * MSAL is instantiated outside the component tree, prevents it from being re-instantiated on re-renders. MSAL instance requires the msal provider to be set up
 */
const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

/* ============= AppWrapper Setup ============= */

const AppWrapper = () => {
	// Capture Auth Token passed from V3
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const authToken = queryString ? urlParams.get('token') : false;

	console.log(authToken);
    return (
      <StrictMode>
        <ThemeContextWrapper>
          <BrowserRouter>
            <Provider store={store}>
              <Routes>
                <Route
                  path="/*"
                  element={
                    (authToken) ?
                      <App authToken={authToken} /> :
                      <MSALApp instance={msalInstance} />
                  }
                />
			  </Routes>
            </Provider>
          </BrowserRouter>
        </ThemeContextWrapper>
      </StrictMode>
    );
};

// Render the AppWrapper component
ReactDOM.render(<AppWrapper />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
